// export const getUrlParameter = name => {
//   if (!name) return;
//   if (typeof window?.location !== 'undefined') {
//     name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
//     var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
//     var results = regex.exec(window?.location?.search);
//     return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
//   }
//   return null;
// };

export const getUrlParameter = name => {
  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search);
    // Try exact name first, then lowercase variant (native apps may send either casing)
    const value = params.get(name) ?? params.get(name.toLowerCase());
    return value !== null ? decodeURIComponent(value) : '';
  }
  return null;
};

export const getAllUrlParameters = ( searchString = '' ) => {
  const url = new URLSearchParams(searchString);

  return Object.fromEntries(url.entries());
};
